var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contact",class:_vm.$mq},[_c('CTABanner'),_c('section',{staticClass:"container"},[_c('ContactForm',{directives:[{name:"animate",rawName:"v-animate",value:('fade-in'),expression:"'fade-in'"}]})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }